import React, { Component, createElement } from 'react'

class Icon extends Component {
  componentDidMount () {
    const { className } = this.props

    const svgClass = document.querySelectorAll(`svg.${className}`)
    if (svgClass.length) {
      svgClass.forEach((svg) => {
        svg.querySelectorAll('g').forEach((element) =>
          element.classList.add(className)
        )
        svg.querySelectorAll('path').forEach((element) =>
          element.classList.add(className)
        )
      })
    }
  }

  render () {
    const { name, className, height, width, size, classes = '' } = this.props
    const { onClick, ...restProps } = this.props
    const isClickable = onClick !== undefined
    const buttonProps = isClickable
      ? {
        role: 'button',
        tabIndex: 0,
        onKeyPress: (event) => {
          if (event.key === 'Enter') {
            onClick();
          }
        },
        onClick,
      }
      : {};

    if (!name || !size) {
      if (!height || !width) {
        return null
      }
    }

    const w = width || size
    const h = height || size

    const splittedName = name.split('.')
    if (splittedName.length <= 1) {
      return null
    }

    const extension = splittedName[1]
    let svgComponent
    if (extension === 'svg') {
      const importedSVG = require(`../assets/icons/${name}`)
      const allProps = { ...restProps, className: `icon-image ${className || ''}`, width: w, height: h}
      svgComponent = createElement(importedSVG.default, allProps)
    }

    return (
      <div
        className={`icon icon-holder ${classes}`}
        style={{
          width: `${w}`,
          height: `${h}`,
          'backgroundSize': `${w} ${h}`
        }}
        {...buttonProps}
      >
        {(svgComponent) || null}
      </div>
    )
  }
}

export default Icon
